
import { computed, defineComponent, onMounted, ref } from 'vue';
import { getSentRequest, PartnerReviewRequestResource } from '@/api/partnerReviewApi';
import RequestPartnerListFilter from '@/components/RequestPartnerListFilter.vue';
import PartnerRequestSentPendingListItem from '@/components/PartnerRequestSentPendingListItem.vue';
import { useStore } from 'vuex';
import { key } from '@/store';

export default defineComponent({
  name: 'RequestSentPage',
  components: { PartnerRequestSentPendingListItem, RequestPartnerListFilter },
  setup() {
    const store = useStore(key);
    const sentRequest = ref<PartnerReviewRequestResource[]>([]);
    const wasRequestComplete = ref(false);

    const filterBy = ref('7d');
    function setFilter(field: string) {
      filterBy.value = field;
      getSentRequestAction(field);
    }

    const noDataFromResponse = computed(() => {
      return wasRequestComplete.value === true && sentRequest.value.length === 0;
    });

    const toggleSidebar = () => {
      store.commit('setSidebarState', !store.state.layout.isSidebarOpen);
    };

    onMounted(() => {
      getSentRequestAction(filterBy.value);
    });

    const getSentRequestAction = (filter: string) => {
      getSentRequest(filter).then(res => {
        sentRequest.value = res;
        wasRequestComplete.value = true;
      });
    };

    return {
      sentRequest,
      noDataFromResponse,
      setFilter,
      filterBy,
      toggleSidebar,
    };
  },
});
